import { render } from "./Winner.vue?vue&type=template&id=70d1c6e6"
import script from "./Winner.vue?vue&type=script&lang=js"
export * from "./Winner.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/ff-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__